<template>
  <footer id="footer_wrapper">
    <div class="container">
      <div class="main_footer">

        <div class="row">
          <div class="col-lg-7">
            <div class="footer_nav">
              <ul class="list-group list-group-horizontal transparent_list">
                <li class="list-group-item pl-0"><router-link to="/">HOME</router-link></li>
                <li class="list-group-item"><router-link to="/information">INFORMATION</router-link></li>
                <li class="list-group-item"><router-link to="/releases">RELEASES</router-link></li>
                <li class="list-group-item"><router-link to="/hyperLink">HYPERLINK</router-link></li>
                <li class="list-group-item"><router-link to="/submission">SUBMISSION</router-link></li>
                <li class="list-group-item"><router-link to="/contact">CONTACT US</router-link></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-5 my-lg-auto">
            <div class="social_links">
              <ul
                class="list-group list-group-horizontal transparent_list justify-content-lg-end justify-content-center">
                <li class="list-group-item"><a href="https://youtube.com/channel/UCk0175IjuulfbwXyD-lOh2A" target="_blank"><i class="fab fa-youtube"></i></a></li>
                <li class="list-group-item"><a href="https://twitter.com/gmnanashi" target="_blank"><i class="fab fa-twitter"></i></a></li>
                <li class="list-group-item"><a href="https://www.facebook.com/GMNanashi/" target="_blank"><i class="fab fa-facebook-square"></i></a></li>
                <li class="list-group-item"><a href="https://www.instagram.com/gmnanashi/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                <li class="list-group-item"><a href="https://soundcloud.app.goo.gl/jbjzJ" target="_blank"><i class="fab fa-soundcloud"></i></a></li>
                <li class="list-group-item"><a href="https://music.apple.com/us/artist/gm-nanashi/1561494105" target="_blank"><i class="fas fa-music"></i></a></li>
                <li class="list-group-item"><a href="https://open.spotify.com/artist/3UGhltIiwrExCxs5CjJQFh?si=enFsVQOiSeOIhTQja9L7FQ&utm_source=copy-link&dl_branch=1" target="_blank"><i class="fab fa-spotify"></i></a></li>
                <li class="list-group-item"><a href="https://www.tiktok.com/@gmnanashi" target="_blank"><i class="fab fa-tiktok"></i></a></li>
                <li class="list-group-item"><a href="https://www.patreon.com/gmnanashi" target="_blank"><i class="fab fa-patreon"></i></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-7">
          </div>
          <div class="col-md-5 my-auto text-md-right text-center">
            <p>© {{ new Date().getFullYear() }} Nanashi</p>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
export default{
  name: 'Footer',
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue